const day = Array.from(Array(31)).map((_, i) => ({ label: String(i + 1), value: i + 1 }))

export default day
